import React, { useState } from 'react';
import SupportTicketList from '../components/SupportTicketList';
import SupportTicketForm from '../components/SupportTicketForm';
import SupportTicketDetail from '../components/SupportTicketDetail';
import { Toaster } from 'react-hot-toast';

import HeaderWithIcon from '../components/common/HeaderWithIcon';

const Support = () => {
  const [currentView, setCurrentView] = useState('list'); // 'list', 'create', 'detail'
  const [selectedTicket, setSelectedTicket] = useState(null);

  const handleCreateNew = () => {
    setCurrentView('create');
  };

  const handleTicketCreated = (ticket) => {
    setCurrentView('list');
    // Optionally show the newly created ticket
    setSelectedTicket(ticket);
    setCurrentView('detail');
  };

  const handleTicketSelect = (ticket) => {
    setSelectedTicket(ticket);
    setCurrentView('detail');
  };

  const handleClose = () => {
    setCurrentView('list');
    setSelectedTicket(null);
  };

  const handleUpdate = () => {
    // This will trigger a refresh of the ticket list
    setCurrentView('list');
  };

  return (
    <div className="min-h-screen relative overflow-hidden">
        <HeaderWithIcon title="Support" />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#4aed88',
                secondary: '#fff',
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: '#ff6b6b',
                secondary: '#fff',
              },
            },
          }}
        />
      {currentView === 'list' && (
        <SupportTicketList 
          onCreateNew={handleCreateNew}
          onTicketSelect={handleTicketSelect}
        />
      )}
      
      {currentView === 'create' && (
        <SupportTicketForm 
          onTicketCreated={handleTicketCreated}
          onClose={handleClose}
        />
      )}
      
      {currentView === 'detail' && (
        <SupportTicketDetail 
          ticket={selectedTicket}
          onClose={handleClose}
          onUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

export default Support;